import agents from './agents'
import disputes from './disputes'
import questionControls from './questionControls'
import general from './general'
import solutions from './solutions'
import suggestions from './suggestions'
import tools from './tools'

export default {
  agents,
  disputes,
  questionControls,
  general,
  solutions,
  suggestions,
  tools,
}
